/**
 * drainLatch — the field drain's re-entrancy latch (Field Cancel spec v3
 * §3.3) and, since 2026-10-28, the per-record capture in-flight signal below.
 * A leaf module with NO imports: drainFieldQueue and fieldOutbox both use it,
 * and neither has to import the other for it.
 *
 * Module-level on purpose (mirrors useDisposalOfflineQueue's latch):
 * remounts and double-fired triggers share ONE latch. A queue item being sent
 * right now is still 'pending' — no status can tell it apart — so this is
 * what discardPendingRecord gates on. It narrows the race; it cannot recall a
 * request already on the wire.
 */

let active = false;

export function setFieldDrainActive(v) { active = v; }

export function isFieldDrainActive() { return active; }

/*
 * The record whose field_capture the drain is sending right now, or null — the
 * in-flight signal for the same-row race fix (2026-10-28, spec D-5). In memory
 * on purpose: nothing is in flight after a restart, so a persisted status would
 * only leave crash residue for four readers to step around. PER RECORD, never
 * the drain-wide latch above (C-2): a hold keyed on `active` would refuse a
 * re-apply tapped while any unrelated record drains. Set by
 * fieldOutbox.claimFieldCapture inside its transaction, cleared by
 * settleFieldCapture, read by enqueueFieldCapture inside its own.
 */
let captureInFlight = null;

export function setFieldCaptureInFlight(recordId) { captureInFlight = recordId; }

export function fieldCaptureInFlight() { return captureInFlight; }
